module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "czewm-box"
  }, [(_vm.data) ? _c('div', {
    staticClass: "czewm-content"
  }, [_c('canvas', {
    ref: "qrcodeCanvas",
    staticClass: "czewm-qrcode"
  }), _vm._v(" "), _c('span', {
    staticClass: "czewm-label"
  }, [_vm._v(_vm._s(_vm.data.networkName) + " " + _vm._s(_vm.$t('all.chongbidizhi')))]), _vm._v(" "), _c('div', {
    staticClass: "czewm-address"
  }, [_c('span', {
    staticClass: "czewm-address-text"
  }, [_vm._v(_vm._s(_vm.data.address))]), _vm._v(" "), _c('img', {
    staticClass: "czewm-address-copy",
    attrs: {
      "src": require("../../../assets/image/fuzhi_18@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.handleCopy
    }
  })]), _vm._v(" "), (_vm.rechargeStatus) ? _c('div', {
    staticClass: "czewm-status"
  }, [_c('span', {
    class: _vm.rechargeStatus === 'success' ? 'czewm-status-success' : 'czewm-status-pending'
  }, [_vm._v("\n          " + _vm._s(_vm.rechargeStatus === 'success' ? _vm.$t('all.chongzhichenggong') : _vm.$t('all.dengdaiquerenzhong')) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "czewm-btn-gradient",
    on: {
      "click": _vm.handleSaveQr
    }
  }, [_vm._v(_vm._s(_vm.$t('all.baocunerweima')))]), _vm._v(" "), _c('div', {
    staticClass: "czewm-btn",
    on: {
      "click": _vm.handleCopy
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fuzhidizhi')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fae70244"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/chongzhierweima/chongzhierweima.vue
// module id = 1008
// module chunks = 1